import { createStore, applyMiddleware, combineReducers } from 'redux'
import thunk from 'redux-thunk';
import rootReducer from '../reducers/rootReducer';
// import { composeWithDevTools } from 'redux-devtools-extension';

// const defaultState = {
//     data: [],

// };

const reducer = combineReducers(rootReducer);

// const middleware = [
//     thunk,
// ];


const configureStore = () =>
    createStore(
        reducer,
        applyMiddleware(thunk)
    );

export default configureStore;